<template>
  <v-skeleton-loader :loading="loading" transition="scale-transition" type="table-tbody">
    <v-card outlined class="pa-4">
      <v-card-text class="pa-0 pb-3">
        <div class="title font-weight-light">Top 10 HCC Conditions</div>
      </v-card-text>
      <horizontal-bar-chart :data="dataCollection" :options="chartOptions" />
    </v-card>
  </v-skeleton-loader>
</template>

<script>
import axios from 'axios';
import HorizontalBarChart from '../charts/HorizontalBarChart';

export default {
  components: {
    HorizontalBarChart,
  },
  props: ['chartLabels', 'chartData', 'loading'],
  data() {
    return {
      dataCollection: {},
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          enabled: false,
        },
        hover: {
          animationDuration: 0,
        },
        scales: {
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                fontFamily: "'Open Sans Bold', sans-serif",
                fontSize: 11,
              },
              scaleLabel: {
                display: false,
              },
              gridLines: {},
              stacked: true,
            },
          ],
          yAxes: [
            {
              gridLines: {
                display: false,
                color: '#fff',
                zeroLineColor: '#fff',
                zeroLineWidth: 0,
              },
              ticks: {
                fontFamily: "'Open Sans Bold', sans-serif",
                fontSize: 12,
              },
              stacked: true,
            },
          ],
        },
        tooltips: {
          callbacks: {
            title(tooltipItems, data) {
              return data.labels[tooltipItems[0].index];
            },
          },
        },
        legend: {
          display: false,
        },
        pointLabelFontFamily: 'Quadon Extra Bold',
        scaleFontFamily: 'Quadon Extra Bold',
      },
    };
  },
  methods: {
    updateChart() {
      this.dataCollection = {
        labels: this.chartLabels,
        datasets: [
          {
            backgroundColor: this.randomColor(),
            data: this.chartData,
          },
        ],
      };
    },
    randomColor() {
      const letters = '0123456789ABCDEF'.split('');
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
  },

  watch: {
    async chartLabels() {
      this.updateChart();
    },
    async chartData() {
      this.updateChart();
    },
  },
};
</script>
